import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Icon from "@mdi/react";
import { mdiClose, mdiArrowLeft } from "@mdi/js";
import { useTranslation } from 'react-i18next';

interface TopNavActionsProps {
  onBack?: () => void; // Make optional for hideBack
  onExit?: () => void;
  disabled?: boolean;
  hideExit?: boolean;
  hideBack?: boolean;
}

const TopNavActions: React.FC<TopNavActionsProps> = ({ onBack, onExit, disabled = false, hideExit = false, hideBack = false }) => {
  const { t } = useTranslation("enrollment");

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, position: 'relative' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        {!hideBack && onBack && (
          <Button
            startIcon={<Icon path={mdiArrowLeft} size={1.2} />}
            onClick={onBack}
            sx={{ alignSelf: 'flex-start', textTransform: 'none', fontSize: 18, width: 'unset' }}
            variant="text"
            disabled={disabled}
          >
            {t("Back")}
          </Button>
        )}
      </div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        {!hideExit && onExit && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative', zIndex: 2 }}>
            <Tooltip title={t("Cancel Registration")} placement="bottom" arrow enterDelay={200} leaveDelay={100}>
              <IconButton
                aria-label="close"
                onClick={onExit}
              >
                <Icon path={mdiClose} size={1.2} />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopNavActions;
